/**
 * WooCommerce Add conditional titles to brand archive pages
 *
 * @since   1.0.0
 * @package premier
 */

(function($) {
    $(document).ready(function() {

        var taxPaBrand = $('.tax-pa_used-cnc-brands');

        if (taxPaBrand.length < 1) {
            return;
        }

        var taxTitleModule = (function() {

            var init = function() {
                var taxPaHeader = document.querySelector('.woocommerce-products-header');
                if (taxPaHeader.children.length > 1) {
                    taxPaHeader.firstElementChild.classList.add('screen-reader-text');
                } else {
                    TweenMax.to(taxPaHeader.firstElementChild, 0.5, {
                        autoAlpha: 1
                    });
                }
            };

            return {
                init: init
            };
        })();

        taxTitleModule.init();

    }); // document.ready
})(jQuery);
